// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
		numberFilterTree: 2,
		//paginationType: boostPFSConfig.custom.infinite_scroll ? 'infinite' : 'default',
		filterTreeMobileStyle: 'style1',
        loadPreviousType: 'infinite',
      	keepScrollbackPositionType: 'history'

	},
	selectors: {
		breadcrumb: '#breadcrumb', // Selector for breadcrumb
		trackingQuickView: '[data-fancybox="quick-view"]' , // Defaut is '',
		trackingAddToCart: 'form[action="/cart/add"] *[type="submit"]', // Default is 'form[action="/cart/add"] *[type="submit"]',
		trackingBuyNow: '.shopify-payment-button, #dynamic-checkout-cart' // Default is '.shopify-payment-button, #dynamic-checkout-cart'
	}
};

var boostPFSTemplate = {
	'saleLabelHtml': '<div class="sale-item icn">' + boostPFSConfig.label.sale + '</div>',
	'soldOutLabelHtml': '<div class="so icn">' + boostPFSConfig.label.sold_out + '</div>',
	'newLabelHtml': '<div class="new icn">' + boostPFSConfig.label.new + '</div>',
	'vendorHtml': '<h4>{{itemVendorLabel}}</h4>',
	'quickViewHtml': '<button class="quick-view-{{itemId}} product-listing__quickview-trigger js-modal-open js-quickview-trigger" type="button" name="button" data-wau-modal-target="quickview" data-product-url="{{itemUrl}}?view=quick">' + boostPFSConfig.label.quick_view + '</button>',
	'imageFlipHtml': '<div class="hidden"><img src="{{imageFlipUrl}}" alt="{{itemTitle}}" /></div>',

	'productGridItemHtml' : '<div class="'+ boostPFSConfig.custom.grid_item_width +' product-index" id="prod-{{itemId}}" data-alpha="{{itemTitle}}" data-price="{{itemPriceNumber}}" data-aos="' + boostPFSConfig.custom.scroll_animation + '" data-product-id="{{itemId}}">' +
								'<div class="ci">' +
									'{{itemNewLabel}}' +
									'{{itemSaleLabel}}' +
									'{{itemSoldoutLabel}}' +
                            	    '<a href="{{itemUrl}}" title="{{itemTitle}}">' +
										'<div class="reveal">' +
											'{{itemFamilyIcon}}' +
											'{{itemImages}}' +
							  			'</div>' +
                            	    '</a>' +
                            	    '{{itemQuickView}}' +
                            	'</div>' +
                            	'<div class="product-details">' +
                            	    '<a href="{{itemUrl}}">' +
                            	        '{{itemVendor}}' +
                            	        '<h3>{{itemTitle}}</h3>' +
                            	    '</a>' +
									'{{itemCollectionURL}}' +
                            	    '<div class="price">{{itemPrice}}</div>' +
                            	    '<div class="product_listing_options">' +
                            	        '{{itemSizeSwatch}}' +
                            	        '{{itemColorSwatch}}' +
                            	        '{{itemAddToCart}}' +
                            	        '{{itemReviews}}' +
                            	    '</div>' +
								'</div>' +
							'</div>',

    // Grid Template
    'productGridItemHtmlold':  '<div id="prod-{{itemId}}" class="product-index {{itemGridWidthClass}} tablet-half mobile-half" data-alpha="{{itemTitle}}" data-price="{{itemPriceNumber}}" data-aos="fadeup">' +
                                '<div class="ci">' +
                                    '{{itemNewLabel}}' +
                                    '{{itemSaleLabel}}' +
                                    '{{itemSoldoutLabel}}' +

                                    '<a href="{{itemUrl}}" title="{{itemTitle}}">' +
                                        '<div class="reveal">' +
											  '{{itemFamilyIcon}}' +
                                              '{{itemImages}}' +
                                        '</div>' +
                                    '</a>' +
                                '</div>' +

                                '<div class="product-info">' +
                                    '{{itemQuickView}}' +
                                '</div>' +

                                '<div class="product-details">' +
                                    '<a href="{{itemUrl}}">' +
                                        '<h3>{{itemTitle}}</h3>' +
                                        '{{itemVendor}}' +
                                    '</a>' +
									'{{itemCollectionURL}}' +
                                    '<div class="price">{{itemPrice}}</div>' +
                                '</div>' +
                            '</div>',

    // Pagination Template
    'previousHtml': '<a href="{{itemUrl}}"><</a>',
    'nextHtml': '<a href="{{itemUrl}}">></a>',
    'pageItemHtml': '<a href="{{itemUrl}}">{{itemTitle}}</a>',
    'pageItemSelectedHtml': '<span class="current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

    // Sorting Template
    'sortingHtml': '<label for="boost-pfs-filter-top-sorting-select">'+ boostPFSConfig.label.sorting + '</label><select class="boost-pfs-filter-top-sorting-select" class="bc-select">{{sortingItems}}</select>',
};


(function() {
	BoostPFS.inject(this);
	// Build Product List
	ProductGridItem.prototype.compileTemplate = function (data, index, totalProduct) {
		if (!data) data = this.data;  // Add this line
		if (!index) index = this.index;  // Add this line
		if (!totalProduct) totalProduct = this.totalProduct;  // Add this line
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add Label
		var itemNewLabelHtml = '';
		var itemSaleLabelHtml = '';
		var itemSoldoutLabelHtml = '';
		if (!soldOut) {
			for (var k = 0; k < data.collections.length; k++) {
				if (data['collections'][k]['handle'] == 'new') {
					itemNewLabelHtml = boostPFSTemplate.newLabelHtml;
					break;
				}
			}
			if (onSale) {
				itemSaleLabelHtml = boostPFSTemplate.saleLabelHtml;
			}
		} else {
			itemSoldoutLabelHtml = boostPFSTemplate.soldOutLabelHtml;
		}
		itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
		itemHtml = itemHtml.replace(/{{itemSoldoutLabel}}/g, itemSoldoutLabelHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add price
		var itemPriceHtml = '';
		if (onSale) {
			itemPriceHtml += '<div class="onsale">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</div>';
			itemPriceHtml += '<div class="was-listing">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '</div>'
		} else {
			itemPriceHtml += '<div class="prod-price">';
			if (priceVaries) {
				itemPriceHtml += boostPFSConfig.label.from_price + ' ' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + ' - ' + Utils.formatMoney(data.price_max, Globals.moneyFormat);
			} else {
				itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			}
			itemPriceHtml += '</div>';
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Images
		var itemImagesHtml = '';
		if (images.length > 0){
			itemImagesHtml += buildImage(images[0]);
			if (boostPFSConfig.custom.image_flip_enable && images.length > 1){
				itemImagesHtml += '<div class="hidden">' + buildImage(images[1]) + '</div>';
			}
		} else {
			itemImagesHtml = buildImage(null);
		}
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Quick view
		var itemQuickViewHtml = boostPFSConfig.custom.quick_view_enable ? boostPFSTemplate.quickViewHtml : '';
		itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

		// Add size swatch
		var itemSizeSwatchHtml = buildSizeSwatch(data);
		itemHtml = itemHtml.replace(/{{itemSizeSwatch}}/g, itemSizeSwatchHtml);

		// Add color swatch
		var itemColorSwatchHtml = buildColorSwatch(data);
		itemHtml = itemHtml.replace(/{{itemColorSwatch}}/g, itemColorSwatchHtml);

		// Add add to cart
		var itemAddToCartHtml = buildAddToCart(data, firstVariant);
		itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);

		// Add Shopify Reviews
		// if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
		// 	var itemReviewsHtml = boostPFSConfig.custom.show_reviews ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' : '';
		// 	itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
		// }

		// Add Reviews.io

		var itemReviewsHtml = buildReviews(data);
		itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

		// add family icons
		var itemFamilyIconHtml = buildFamilyIcon(data);
		itemHtml = itemHtml.replace(/{{itemFamilyIcon}}/g, itemFamilyIconHtml);

		// add boys/mens collection link
		var itemCollectionURLHtml = buildParentCollection(data);
		itemHtml = itemHtml.replace(/{{itemCollectionURL}}/g, itemCollectionURLHtml);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemPriceNumber}}/g, data.price_min);
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	}


	function buildParentCollection(data){
		var html = '';
		var productHandle = data.handle;
		var productType = data.product_type;

		const currentURL = window.location.href;
		const currentURLTrimmed = currentURL.split('/collections/');
		const currentCollection = currentURLTrimmed[1];

		if(currentURL.includes('collections')){
			if (productHandle.includes('men') && !currentCollection.includes('men')) {
				var collectionURL = '<a href="/collections/men">Mens</a>';
			}
			else if(productHandle.includes('boys') && !currentCollection.includes('boy')){
				var collectionURL = '<a href="/collections/boys">Boys</a>';
			}
			else{
				var collectionURL = '';
			}
		}
		else{
			var collectionURL = '';
		}

		html = collectionURL;
		return html;
	}

	function buildFamilyIcon(data){
		var html = '';
		var productTags = data.tags;
		if (productTags.includes('family-set')) {
			var familyIcon = '<div class="icon-wrapper"><div class="tooltip"><img src="https://cdn.shopify.com/s/files/1/1956/9637/files/family-set.svg?v=1673956095"><span class="tooltiptext">Available in Family</span></div></div>';
		}
		else if (productTags.includes('men-and-boys')) {
			var familyIcon = '<div class="icon-wrapper"><div class="tooltip"><img src="https://cdn.shopify.com/s/files/1/1956/9637/files/men-and-boys.svg?v=1673956742"><span class="tooltiptext">Available in Men and Boys</span></div></div>';
		}
		else if (productTags.includes('womens-and-girls')) {
			var familyIcon = '<div class="icon-wrapper"><div class="tooltip"><img src="https://cdn.shopify.com/s/files/1/1956/9637/files/women-and-girls.svg?v=1673956748"><span class="tooltiptext">Available in Womens and Girls</span></div></div>';
		}
		else{
			var familyIcon = '';
		}
		html = familyIcon;
		return html;
	}

	function buildReviews(data){
		var html = '';
		var i = "";
		var productSKUS = data.skus;
		var productSKUSFormatted = productSKUS.join(';');
		var productHandle = data.handle;
		var variantBarcodes = data.barcodes;
		var variantBarcodesFormatted = variantBarcodes.join(';');
		var reviewsHtml = '<div class="ruk_rating_snippet" data-sku="'+ productHandle + ';' + productSKUSFormatted + ';' + variantBarcodesFormatted + '"></div>';

		html = reviewsHtml;
		return html;
	}

	function buildImage(image) {

		var html = '<div>' +
						'<img class="lazyload lazyload-fade" ' +
							'id="{{imageId}}" ' +
							'data-src="{{imageUrl}}" ' +
							'data-sizes="auto" ' +
							'alt="{{itemTitle}}"> ' +
					'</div>';
		if (image && image.src){
			var imagePadding = image.height / image.width * 100;
			html = html.replace(/{{imageUrl}}/g, Utils.optimizeImage(image.src, '500x'));
			html = html.replace(/{{imageId}}/g, image.id);
			html = html.replace(/{{imagePadding}}/g, imagePadding + '%');
		} else {
			html = html.replace(/{{imagePadding}}/g, '100%').replace(/{{imageId}}/g, '').replace(/{{imageUrl}}/g, boostPFSConfig.general.no_image_url);
		}
		return html;
	}

	function buildSizeSwatch(data){
		var html = '';
		var swatchItems = [];
		var sizeOptionIndex = 0;
		if (boostPFSConfig.custom.product_info == 'sizes' && data.available){
			var sizeKeys = ['size', 'sizes'];
			var sizeValues = [];
			data.variants.forEach(function(variant){
				var sizeValue = null;
				variant.merged_options.forEach(function(merged_option, optionIndex){
					var key = merged_option.split(':')[0];
					var value = merged_option.split(':')[1];
					if (sizeKeys.indexOf(key.toLowerCase().trim()) != -1 && sizeValues.indexOf(value.toLowerCase().trim()) == -1){
						sizeValue = value;
						sizeValues.push(value.toLowerCase().trim());
						sizeOptionIndex = optionIndex;
					}
				})
				if (sizeValue){
					var swatchItem ='<li data-option-title="{{sizeValue}}" data-href="{{variantImage}}" class="color {{sizeValue}}">' +
										'<a href="{{variantUrl}}">{{sizeValue}}</a>' +
										'</li>';

					var variantImage = variant.image ? variant.image : (data.images_info.length > 0 ? data.images_info[0].src : boostPFSAppConfig.general.no_image_url);
					swatchItem = swatchItem.replace(/{{variantImage}}/g, Utils.optimizeImage(variantImage, 'large'));
					swatchItem = swatchItem.replace(/{{sizeValue}}/g, sizeValue);
					swatchItem = swatchItem.replace(/{{variantUrl}}/g, '{{itemUrl}}?variant=' + variant.id);
					swatchItems.push(swatchItem);
				}
			});
			if (swatchItems.length > 0){
				html = '<div class="size-swatch"><ul data-option-index="' + sizeOptionIndex + '" class="size options">' + swatchItems.join(' ') +'</ul></div>';
			}
		}
		return html;
	}

	function buildColorSwatch(data){
		var html = '';
		var swatchItems = [];
		var colorOptionIndex = 0;
		if (boostPFSConfig.custom.product_info == 'colors' && data.available){
			var colorKeys = ['color', 'colors', 'colour' ,'colours'];
			var colorValues = [];
			data.variants.forEach(function(variant){
				var colorValue = null;
				variant.merged_options.forEach(function(merged_option, optionIndex){
					var key = merged_option.split(':')[0];
					var value = merged_option.split(':')[1];
					if (colorKeys.indexOf(key.toLowerCase().trim()) != -1 && colorValues.indexOf(value.toLowerCase().trim()) == -1){
						colorValue = value;
						colorValues.push(value.toLowerCase().trim());
						colorOptionIndex = optionIndex;
					}
				})
				if (colorValue){
					var swatchItem ='<li data-option-title="{{colorValue}}" data-href="{{variantImage}}" class="color {{colorValue}}">' +
										'<a href="{{variantUrl}}">' +
											(boostPFSConfig.custom.color_swatch_options == 'variant-image' && variant.image ?
												'<img class="variant-image" src="{{variantImage}}" alt="{{colorValue}}">'
												:
												'<span class="custom-image css-color" style="width: 25px; height: 25px; '+
												'background-color: {{backgroundColor}}; background-image: url({{backgroundImage}});">' +
												'</span>'
											) +
										'</a>'
									'</li>';

					var variantImage = variant.image ? variant.image : (data.images_info.length > 0 ? data.images_info[0].src : boostPFSAppConfig.general.no_image_url);
					swatchItem = swatchItem.replace(/{{variantImage}}/g, Utils.optimizeImage(variantImage, 'large'));
					swatchItem = swatchItem.replace(/{{variantUrl}}/g, '{{itemUrl}}?variant=' + variant.id);
					swatchItem = swatchItem.replace(/{{colorValue}}/g, colorValue);
					swatchItem = swatchItem.replace(/{{backgroundColor}}/g, Utils.slugify(colorValue).split('-').pop());

					var backgroundImage = boostPFSAppConfig.general.file_url.split('?')[0] + Utils.slugify(colorValue) + '.png';
					swatchItem = swatchItem.replace(/{{backgroundImage}}/g, backgroundImage);
					swatchItems.push(swatchItem);
				}
			});
			if (swatchItems.length > 0){
				html = '<div class="col-swatch"><ul data-option-index="' + colorOptionIndex + '" class="size options">' + swatchItems.join(' ') +'</ul></div>';
			}
		}
		return html;
	}

	function buildAddToCart(data, firstVariant){
		var html = '';
		if (boostPFSConfig.custom.product_info == 'add_to_cart' && !boostPFSConfig.custom.quick_view_enable){
			html = '<div class="quick-add-to-cart">'
			if (data.variants && data.variants.length <= 1 && data.available && firstVariant){
				html += '<form action="/cart/add" method="post" data-money-format="' + boostPFSAppConfig.shop.money_format + '" data-product-id="{{itemId}}" enctype="multipart/form-data" class="product_form">' +
							'<div class="product-variants"></div>' +
							'<input  type="hidden" id="' + firstVariant.id + '" name="id" data-sku="' + firstVariant.sku +'" value="'+ firstVariant.id +'" />' +
							'<div class="product-add">' +
								'<input type="submit" name="button" class="add clearfix AddtoCart" value="'+ boostPFSConfig.label.add_to_cart +'" />' +
							'</div>' +
						'</form>';
			} else {
				html += '<div class="product-add">' +
							'<a class="add options button clearfix" href="{{itemUrl}}">' + boostPFSConfig.label.select_options + '</a>' +
						'</div>';
			}
			html += '</div>'

		}
		return html;
	}

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build wrapper
			paginationHtml = paginationHtml.replace(/{{paginateWrapperClass}}/g, 'twelve');

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
				return html;
			}
		}
	};


	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function () {
		if (typeof Shopify !== 'undefined') {
			Shopify.theme.quickview.init();
		}
	};

	// Capitalize label of filter option
	FilterResult.prototype.afterRender = function () {
		var data = this.data;

		var from = Globals.queryParams.page == 1 ? Globals.queryParams.page : (Globals.queryParams.page - 1) * Globals.queryParams.limit + 1;
		var to = Globals.queryParams.page * Globals.queryParams.limit;
		jQ(Selector.bottomPagination).find('.count').html(boostPFSConfig.label.showing_items + ' ' + from + '-' + to + ' / ' + data.total_product);

		if (window.SPR) {
			SPR.initDomEls();
			SPR.loadBadges();
		}
	};

})();
